import { InfositeController } from './infosite-controller';
import { InfositeControllerExtended } from './infosite-controller-extended';
import { SearchController } from './search-controller';
import { SailingSummaryController } from './sailing-summary-controller';
import { CruisePromotionsController } from './cruise-promotions-controller';

export const controllers = [
  InfositeController,
  InfositeControllerExtended,
  SearchController,
  SailingSummaryController,
  CruisePromotionsController
];
